import React, { useEffect, useState } from "react";
import "./approval-screen.scss";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ActiveLink from "../../../layout/active-link/ActiveLink";
import Header from "../../../layout/header/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  getAssessmentById,
  putAssessmentApproveReject,
} from "../../../../api/services/assessment-apis";
import { toast } from "react-toastify";

const ApprovalScreen = () => {
  const [tableData, setTableData] = useState([]);

  const getRowColor = (index: any) => {
    return index % 2 === 1 ? "#ffffff" : "white";
  };
  const location = useLocation();
  const data = location.state;
  const navigate = useNavigate();
  const AssessmentDetails = location.state?.AssessmentDetails;
  console.log(data, AssessmentDetails);
  const [answers, setAnswers] = React.useState<any[]>([]);
  const [isOpen, setPopupClose] = useState(false);

  useEffect(() => {
    getAssessmentById(AssessmentDetails?.setName)
      .then((data: any) => {
        console.log("Data", data);
        setTableData(data.data.sectionList);
      })
      .catch((error) => {
        // handle error
        toast.error(error);
        console.log(error);
      });
  }, []);

  const handleAnswerChange = (id: number) => (eve: any) => {
    const indexOfSelected = answers.findIndex((val) => val.id == id);
    indexOfSelected !== -1 && answers.splice(indexOfSelected, 1);
    if (eve.target.value) {
      setAnswers([...answers, { id: id, suggestion: eve.target.value }]);
    } else {
      setAnswers([...answers]);
    }
  };

  const onPopupClose = () => {
    setPopupClose(false);
  };

  const openPopUp = (item: any) => {
    setPopupClose(true);
    setAnswers(item.options);
  };


  const handleSubmit = (from: string) => {
    if (from == "approved" || from == "rejected") {
      const payload = {
        setID: AssessmentDetails.setId,
        setName: AssessmentDetails.setName,
        domain: AssessmentDetails.domain,
        createdBy: AssessmentDetails.createdBy,
        status: from,
        createdDate: AssessmentDetails.createdOn,
        updatedBy: "LTIM",
        updatedOn: AssessmentDetails.updatedOn,
        questionList: tableData,
      };
      putAssessmentApproveReject(AssessmentDetails.setId, payload)
        .then((data: any) => {
          console.log(data);
          toast.success(data.data.message);
          navigate("/assessment"); // Navigate to assessment page on success
        })
        .catch((error) => {
          // handle error
          toast.error(error);
          console.log(error);
        });
    } else {
      navigate("/assessment"); // Navigate to assessment page without updating status
      console.log("submit", answers);
    }
  };

  const today = new Date(AssessmentDetails.createdTimestamp);
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  const currentDate = month + "/" + date + "/" + year;

  return (
    <div className="container">
      <Header />
      <div className="app-pageSize">
        {!data?.flag ? (
          <ActiveLink targetLink="Approval Submission" />
        ) : (
          <div className="target-link">
            <Link to="/assessment">Assesment</Link>
            <p style={{ fontSize: "10px" }}>&#10095;</p>
            <p> Approval </p>
          </div>
        )}
        {/* <div> */}
        <div style={{ boxShadow: "0.5px 0.5px 0px 0px grey" }}>
          <div
            className="my-page"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {data?.flag ? (
              <h4 className="my-page">
                Approval ID : {AssessmentDetails.setId}
              </h4>
            ) : (
              <h4 className="my-page">Approval Submission </h4>
            )}
            {AssessmentDetails?.status === "Initiated" && (
              <button className="mail-button">Send Reminder</button>
            )}
          </div>
          <div className="input-container-approval-submit">
            <div className="container px-5 py-3">
              <div className="row mb-2">
                <div className="row col-sm-6">
                  <label htmlFor="domain" className="approvalLabel col-sm-4">
                    Domain:
                  </label>
                  <div className="col-sm-8">
                    <span className="content">{AssessmentDetails?.domain}</span>
                  </div>
                </div>
                {/* {data?.flag && ( */}
                <div className="row col-sm-6">
                  <label htmlFor="domain" className="approvalLabel col-sm-4">
                    Status:
                  </label>
                  <div className="col-sm-8">
                    <span className="content">{AssessmentDetails?.status}</span>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="row col-sm-6">
                  <label htmlFor="domain" className="approvalLabel col-sm-4">
                    Created Date:
                  </label>
                  <div className="col-sm-8">
                    <span className="content">
                      {AssessmentDetails?.createdOn &&
                        new Date(AssessmentDetails.createdOn)
                          .toISOString()
                          .split("T")[0]}
                    </span>
                  </div>
                </div>
                {/* )} */}
                {/* {data?.flag && ( */}
                <div className="row col-sm-6">
                  <label htmlFor="domain" className="approvalLabel col-sm-4">
                    Created By:
                  </label>
                  <div className="col-sm-8">
                    <span className="content">
                      {AssessmentDetails?.createdBy}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="row col-sm-6">
                  <label htmlFor="domain" className="approvalLabel col-sm-4">
                    Approved/
                    <br />
                    Rejected By:
                  </label>
                  <div className="row col-sm-6">
                    <span className="content">
                      {AssessmentDetails.updatedBy}
                    </span>
                  </div>
                </div>
                <div className="row col-sm-6">
                  <label htmlFor="domain" className="approvalLabel col-sm-4">
                    Set Name:
                  </label>
                  <div className="row col-sm-6">
                    <span className="content">
                      {AssessmentDetails?.setName}
                    </span>
                  </div>
                </div>
                {/*  )} */}
              </div>
            </div>
          </div>
        </div>
        <br />
        {/* popup component */}
        {isOpen && (
          <div className="popup_container">
            <div className="popup">
              <div className="popup-content">
                {/* dropdown */}
                <>
                  <div className="header-container">
                    <span>Answers</span>
                    <span>Suggestion</span>
                    <span>Score</span>
                  </div>
                  <div className="body-container">
                    {answers.map((row: any, indx: number) => (
                      <>
                        <div className="options-align">
                          <span>{row.answer}</span>
                          <span>{row.suggestion}</span>
                          <span>{row.score===null||row.score===undefined?"-":row.score}</span>
                        </div>
                        <br />
                      </>
                    ))}
                  </div>

                  <span className="closebutton-div">
                    <button className="closeButton" onClick={onPopupClose}>
                      Close
                    </button>
                  </span>

                  <br />
                  <br />
                </>
                <br />
                <br />
              </div>
            </div>
          </div>
        )}
        <div style={{ boxShadow: "0px 0.5px 0.5px 0px grey" }}>
 
          <div className="table-container">
            <table className="custom-table">
              <thead>
                <tr>
                  <th className="approval-heading" style={{ width: "40px" }}>
                    S. No
                  </th>
                  <th className="approval-heading">Section Name</th>
                  <th className="approval-heading">Question</th>
                  <th className="approval-heading">Answer</th>
                  <th className="approval-heading">Suggestion</th>
                  <th className="approval-heading">Score</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  let serialNumber = 1; // Initialize a global counter
                  return tableData.map((section: any, sectionIndex: number) =>
                    section.questionList.map(
                      (question: any, questionIndex: number) => (
                        <tr key={question.quesId}>
                          <td>{serialNumber++}</td>
                          <td>{section.sectionName}</td>{" "}
                          {/* Section Name Column */}
                          <td>{question.quesDscr}</td>
                          <td colSpan={3} className="options-container">
                            {question.options.map((option: any) => (
                              <div key={option.optionId} className="option-table-row">
                                <div className="option-cell answer-cell">
                                  {option.answer}
                                </div>

                                <div className="option-cell suggestion-cell">
                                  {option.suggestion}
                                </div>

                                <div className="option-cell score-cell">
                                  {option.score ?? "-"}
                                </div>
                              </div>
                            ))}
                          </td>
                        </tr>
                      )
                    )
                  );
                })()}
              </tbody>
            </table>
          </div>
        </div>

        <div className="submit-div">
          {AssessmentDetails?.status.toLowerCase() === "pending" && (
            <>
              <button
                className="submit-btn"
                onClick={() => handleSubmit("approved")}
              >
                Approve
              </button>
              <button
                className="submit-btn ml-5"
                onClick={() => handleSubmit("rejected")}
              >
                Reject
              </button>
            </>
          )}
          <button
            className="submit-btn ml-5"
            onClick={() => handleSubmit("close")}
          >
            Close
          </button>
        </div>

        {/* </div> */}
      </div>
    </div>
  );
};

export default ApprovalScreen;
